import React, { Children } from 'react';
import { List, ListItem } from '@applatform/design-system';

interface NavProps {
  children: React.ReactNode;
}

function Nav({ children }: NavProps) {
  return (
    <nav aria-label="Main Navigation">
      <List css={{ listStyleType: 'none', p: 0 }}>
        {Children.map(children, (child) => (
          <ListItem>{child}</ListItem>
        ))}
      </List>
    </nav>
  );
}

export default Nav;
